export function getCalendarHref(fullName: string, email: string): string {
  const text = encodeURIComponent(`Meeting with ${fullName}`);
  const add = encodeURIComponent(email);
  return `https://calendar.google.com/calendar/r/eventedit?text=${text}&add=${add}`;
}
